import React from 'react';
import IconButton from '../iconButton/IconButton';
import Check from '../iconography/icons/Check';
import CrossChunky from '../iconography/icons/CrossChunky';
import { useTheme } from '../theme-context';

interface INotificationBar {
    'data-testid'?: string;
    type?: 'success' | 'warning' | 'error' | 'neutral';
    closeHandler: () => void;
    showCloseButton?: boolean;
    children: React.ReactNode;
}

const NotificationBar = ({
    'data-testid': dataTestId,
    type,
    closeHandler,
    showCloseButton,
    children,
}: INotificationBar): React.ReactElement => {
    // types: "neutral", "success", "warning","error"

    const { styles } = useTheme();

    let notificationClasses = '';

    let notificationIconClasses = '';

    switch (type) {
        case 'success':
            notificationClasses = 'eds-notification-bar--success';
            notificationIconClasses = 'eds-icon-button--success';
            break;
        case 'warning':
            notificationClasses = 'eds-notification-bar--warning';
            notificationIconClasses = 'eds-icon-button--warning';
            break;
        case 'error':
            notificationClasses = 'eds-notification-bar--error';
            notificationIconClasses = 'eds-icon-button--error';
            break;
        default:
            notificationClasses = 'eds-notification-bar--neutral';
            notificationIconClasses = 'eds-icon-button--neutral';
            break;
    }

    let fillIcon = styles.colors['grey-06'].color;

    if (type && ['error', 'success'].indexOf(type) >= 0) {
        fillIcon = styles.colors['brand-white'].color;
    }

    return (
        <div
            className={`eds-notification-bar--has-close eds-notification-bar ${notificationClasses}`}
            data-testid={dataTestId}
        >
            {type === 'success' ? (
                <div className="eds-notification-bar__icon">
                    <IconButton
                        iconType={<Check fill={fillIcon} />}
                        onClick={closeHandler}
                        data-testid="success-icon-button"
                    />
                </div>
            ) : undefined}
            <div className="eds-notification-bar__content">
                <div className="eds-notification-bar__content-child">
                    {children}
                </div>
            </div>
            {showCloseButton ? (
                <div className="eds-notification-bar__close eds-l-pad-right-2 eds-l-pad-vert-1">
                    <span
                        className={`eds-icon-button ${notificationIconClasses}`}
                        data-testid="close-button"
                    >
                        <IconButton
                            iconType={<CrossChunky fill={fillIcon} />}
                            onClick={closeHandler}
                            data-testid="close-icon-button"
                        />
                    </span>
                </div>
            ) : undefined}
        </div>
    );
};

export default NotificationBar;
